import { FormControl, InputLabel } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBR from "date-fns/locale/pt-BR";
import { Controller, useFormContext } from "react-hook-form";
import { HelperText } from "../../../../components/Errors/HelperText";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import InputMask from "react-input-mask";
import styles from "../Cadastro.module.css";
import { useEffect, useState } from "react";
import servOcupante from "../../../../services/login/servOcupante";
import { validarCnpj, validarCpf } from "../../../../infra/utils/ValidacaoCpf";

const Geral = ({ disableCampos, setOpen, setDisableAba, setErrorMessage, setOpenError, setPodeSalvar, recordForEdit, situacao, cnpjInvalido, setCnpjInvalido, cpfInvalido }) => {
    const { control, register, setValue, watch, setError, clearErrors, formState: { errors } } = useFormContext();
    const [editavel, setEditavel] = useState(false);
    const inscricao = watch("inscricao");

    useEffect(() => {
        if (inscricao && validarCnpj(inscricao)) {
            setCnpjInvalido(false); 
            clearErrors("inscricao");
        }
    }, [inscricao]);

    useEffect(() => {
        const situacaoEditaveis = [0];

        if (situacaoEditaveis.includes(situacao)) {
            setEditavel(false);
        } else {
            setEditavel(true);
        }
    }, [situacao]);

    const verificarInscricaoCadastro = async (inscricao) => {
        const inscricaoSemMascara = inscricao.replace(/\D/g, "");

        if (inscricaoSemMascara.length === 14) {
            const response = await servOcupante.VerificarCadastro(inscricaoSemMascara);

            if (response.Success) {
                if (response.Content) {
                    setErrorMessage("CNPJ de ocupante já cadastrado");
                    setError("inscricao", { type: "manual", message: "CNPJ de ocupante já cadastrado" });
                    setDisableAba(true);
                    setPodeSalvar(false);
                    setOpen(true);
                    setOpenError(true);
                } else {
                    clearErrors("inscricao");
                    setPodeSalvar(true);
                    setDisableAba(false);
                    setOpen(false);
                    setOpenError(false);
                }
            } else {
                setErrorMessage(`Erro ao verificar inscrição: ${response.Message}`);
                setOpenError(true);
            }
        }
    }

    return (
        <div className={styles['input-container']} style={{ padding: "40px" }}>
            <Controller 
                name="nome"
                control={control}
                render={({ field }) => (
                    <FormControl variant="outlined">
                        <InputLabel htmlFor="ocupante-nome" shrink style={{ color: "#B8B8B8" }} >
                            Nome
                        </InputLabel>
                        <WhiteInput 
                                fullWidth
                                placeholder="Nome" 
                                type="text"
                                id="ocupante-nome" 
                                error={!!errors.nome}
                                autoComplete="off"
                                {...field} 
                                readOnly={disableCampos || editavel}
                                className={`${errors?.nome ? styles.campoComValorErrado : ""}`}
                            />
                        { errors?.nome ? (
                            <HelperText text={errors?.nome?.message} />
                        ) : ''}
                    </FormControl>
                )}
            />
            <Controller 
                name="inscricao"
                control={control}
                render={({field: { onChange, onBlur, value }}) => (
                    <FormControl variant="outlined" className={styles['campos-m']}>
                        <InputLabel htmlFor="consulta-inscricao" shrink sx={{ color: "#b8b8b8" }} >Inscrição</InputLabel>
                        <InputMask
                            mask={ "**.***.***/****-99" }
                            onChange={onChange}
                            readOnly={disableCampos || editavel}
                            onBlur={(e) => {
                                onBlur();
                                const inscricaoSemMascara = e.target.value.replace(/\D/g, "");
                                const situacaoNaoEditaveis = [1, 3, 4, 5, 6, 7];

                                if(situacaoNaoEditaveis.includes(situacao))return;                   

                                if (inscricaoSemMascara.length === 14 && recordForEdit?.Inscricao !== inscricaoSemMascara) {
                                    verificarInscricaoCadastro(e.target.value);
                                } else {
                                    clearErrors("inscricao");
                                    setDisableAba(false);
                                    setPodeSalvar(true);
                                    setOpen(false);
                                    setOpenError(false);
                                }
                            }}
                            value={value}
                            id="consulta-inscricao"
                        >
                            { inputProps => (
                                <WhiteInput
                                    fullWidth 
                                    placeholder="CNPJ" 
                                    name="Inscricao" 
                                    {...inputProps}
                                    readOnly={disableCampos || editavel}
                                    autoComplete="off"
                                    className={`${errors?.inscricao || cnpjInvalido ? styles.campoComValorErrado : ""}`}
                                />
                            )}
                        </InputMask>
                        { errors?.inscricao || cnpjInvalido ?  (
                            <HelperText text={cnpjInvalido ? "CNPJ inválido." : errors?.inscricao ? errors?.inscricao?.message : ""} />
                        ) : '' }
                    </FormControl>
                )}
            />
            <div className={styles['input-ocupante']}>
                <Controller 
                    name="numeroTermoAutorizacao"
                    control={control}
                    rules={{ valueAsNumber: true }}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="ocupante-numeroTermoAutorizacao" shrink sx={{ color: "#b8b8b8" }} >Termo de aut. (Nº ATO)</InputLabel>
                            <WhiteInput 
                                fullWidth
                                placeholder="Nº ATO" 
                                type="text"
                                id="ocupante-numeroTermoAutorizacao" 
                                error={!!errors.numeroTermoAutorizacao}
                                autoComplete="off"
                                inputProps={{ autoComplete: "off" }}
                                value={field.value ? new Intl.NumberFormat("pt-BR").format(Number(field.value)) : ""}
                                 onChange={(e) => {
                                    const onlyNumbers = e.target.value.replace(/\D/g, "");
                                    field.onChange(onlyNumbers);
                                }}
                                onKeyDown={(e) => {
                                    if ([".", ",", "-", "+", "e", "E"].includes(e.key)) {
                                    e.preventDefault();
                                    }
                                }}
                                readOnly={disableCampos}
                                className={`${errors?.numeroTermoAutorizacao ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.numeroTermoAutorizacao ?  (
                                <HelperText text={errors?.numeroTermoAutorizacao?.message} />
                            ) : '' }
                        </FormControl>
                    )}
                />
                <FormControl variant="outlined" className={styles['campos-m']}>
                    <InputLabel htmlFor="ocupante-dataAto" shrink style={{ color: "#b8b8b8", zIndex: 0}}>
                        Data autorização
                    </InputLabel>
                    <Controller 
                        name="dataAto"
                        control={control}
                        render={({ field }) => (
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} >
                                <DatePicker 
                                    {...field}
                                    error={!!errors.dataAto}
                                    inputFormat="dd/MM/yyyy"
                                    label="Data autorização"
                                    readOnly={disableCampos}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{color: "#fff"}} className={`${errors?.dataAto ? styles.campoComValorErrado : ""}`} />
                                            <span style={{ position: "absolute", top: 38, right: 15, color: "white", svg: "white", input: "white", label: "white" }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                />
                            </LocalizationProvider>
                        )}
                    />
                    { errors?.dataAto ?  (
                        <HelperText text={errors?.dataAto?.message} />
                    ) : '' }
                </FormControl>
            </div>
             <div className={styles['input-ocupante']}>
                <Controller 
                    name="processoAnatel"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="ocupante-processoAnatel" shrink sx={{ color: "#b8b8b8" }} >N° Processo ANATEL</InputLabel>
                            <WhiteInput 
                                fullWidth
                                placeholder="N° Processo ANATEL" 
                                type="text"
                                id="ocupante-processoAnatel" 
                                error={!!errors.processoAnatel}
                                autoComplete="off"
                                {...field} 
                                readOnly={disableCampos}
                                className={`${errors?.processoAnatel ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.processoAnatel ?  (
                                <HelperText text={errors?.processoAnatel?.message} />
                            ) : '' }
                        </FormControl>
                    )}
                />
                <Controller 
                    name="numeroContrato"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="ocupante-numeroContrato" shrink sx={{ color: "#b8b8b8" }} >Nº Contrato junto a distribuidora</InputLabel>
                            <WhiteInput 
                                fullWidth
                                placeholder="Nº Contrato" 
                                type="text"
                                id="ocupante-numeroContrato" 
                                error={!!errors.numeroContrato}
                                autoComplete="off"
                                inputProps={{ autoComplete: "off" }}
                                {...field} 
                                readOnly={disableCampos}
                                className={`${errors?.numeroContrato ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.numeroContrato ?  (
                                <HelperText text={errors?.numeroContrato?.message} />
                            ) : '' }
                        </FormControl>
                    )}
                />
            </div>
            <div className={styles['input-ocupante']}>
                <Controller 
                    name="nomeRepresentante"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="ocupante-nomeRepresentante" shrink sx={{ color: "#b8b8b8" }} >Nome do representante</InputLabel>
                            <WhiteInput 
                                fullWidth
                                placeholder="Nome do representante" 
                                type="text"
                                id="ocupante-nomeRepresentante" 
                                error={!!errors.nomeRepresentante}
                                autoComplete="off"
                                {...field} 
                                readOnly={disableCampos}
                                className={`${errors?.nomeRepresentante ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.nomeRepresentante ?  (
                                <HelperText text={errors?.nomeRepresentante?.message} />
                            ) : '' }
                        </FormControl>
                    )}
                />
                <Controller 
                    name="cpfRepresentante"
                    control={control}
                    render={({field: { onChange, value }}) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="consulta-cpfRepresentante" shrink sx={{ color: "#b8b8b8" }} >CPF representante</InputLabel>
                            <InputMask
                                mask={ "999.999.999-99" }
                                onChange={(e) => {
                                    if (disableCampos) return;
                                    onChange(e);
                                    const cpf = e.target.value;
                                    if (cpf && !validarCpf(cpf)) {
                                        setError("cpfRepresentante", {
                                        type: "manual",
                                        message: "CPF inválido",
                                        });
                                    } else {
                                        clearErrors("cpfRepresentante");
                                    }
                                }}
                                value={value}
                                readOnly={disableCampos}
                                id="consulta-cpfRepresentante"
                            >
                                { inputProps => (
                                    <WhiteInput
                                        fullWidth 
                                        placeholder="CPF" 
                                        name="cpfRepresentante" 
                                        {...inputProps}
                                        readOnly={disableCampos}
                                        autoComplete="off"
                                        className={`${errors?.cpfRepresentante || cpfInvalido ? styles.campoComValorErrado : ""}`}
                                    />
                                )}
                            </InputMask>
                            { errors?.cpfRepresentante || cpfInvalido ?  (
                                <HelperText text={cpfInvalido ? "CPF inválido." : errors?.cpfRepresentante?.message} />
                            ) : '' }
                        </FormControl>
                    )}
                />
            </div>
        </div>
    )
}

export { Geral }